const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子', heat: '1286万', trend: 'up', change: '+3', hot: true },
  { rank: 2, title: '女团成员恋情曝光男方身份引热议', heat: '1102万', trend: 'up', change: '+1', hot: true },
  { rank: 3, title: '综艺录制现场冲突事件持续发酵', heat: '987万', trend: 'down', change: '-1', hot: false },
  { rank: 4, title: '知名网红偷税漏税工作室发声明', heat: '856万', trend: 'up', change: '+5', hot: true },
  { rank: 5, title: '年度最甜CP官宣分手粉丝破防', heat: '743万', trend: 'down', change: '-2', hot: false },
  { rank: 6, title: '某国际电影节获奖影片陷抄袭争议', heat: '621万', trend: 'new', change: '新', hot: true },
  { rank: 7, title: '娱乐圈"清朗行动"再升级引关注', heat: '508万', trend: 'up', change: '+2', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium mb-3">
              <i className="ri-bar-chart-line"></i>
              实时热度
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              今日热搜榜
            </h2>
          </div>
          <div className="flex items-center gap-2 bg-background-100 rounded-full px-1 py-1 border border-background-200/70">
            <span className="px-4 py-1.5 rounded-full text-sm bg-primary-500 text-background-50 font-medium whitespace-nowrap cursor-pointer">实时</span>
            <span className="px-4 py-1.5 rounded-full text-sm text-foreground-500 font-medium whitespace-nowrap cursor-pointer hover:text-foreground-700">今日</span>
            <span className="px-4 py-1.5 rounded-full text-sm text-foreground-500 font-medium whitespace-nowrap cursor-pointer hover:text-foreground-700">本周</span>
          </div>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden max-w-4xl mx-auto">
          {rankingItems.map((item, idx) => (
            <a
              key={item.rank}
              href="#"
              className={`flex items-center gap-4 px-5 md:px-8 py-4 hover:bg-background-50 transition-colors cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-300 text-background-50' :
                item.rank === 3 ? 'bg-accent-400 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base font-medium text-foreground-900 truncate">
                    {item.title}
                  </span>
                  {item.hot && (
                    <span className="flex-shrink-0 bg-primary-100 text-primary-600 text-xs px-2 py-0.5 rounded-full font-medium">
                      热
                    </span>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs md:text-sm font-medium text-foreground-500 whitespace-nowrap">
                  {item.heat}
                </span>
                <span className={`text-xs font-medium whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-500' :
                  item.trend === 'new' ? 'text-accent-500' :
                  'text-foreground-400'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-s-line mr-0.5"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-s-line mr-0.5"></i>}
                  {item.change}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}